// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.divSearchLyceum{
    min-height: 100vh;
    display: flex;
    flex-direction: row;
    color: white;
}

.divSearchLyceumMenu{
  display: flex;
  flex-direction: column;
  width: 100px;
  background-color: #FFFFFF;
  color: black;
  padding:32px 0 32px 0px ;
}

.divSearchLyceumContent{
  display: flex;
  flex-direction: column;
  gap:24px;
  padding:32px;
  width: calc(100% - 100px);
  background-color: #6051b7;
  margin-left: 100px;
}

.divSearchLyceumContentSub{
  display: flex;
  flex-direction: column;
  padding: 32px 0px 0px 64px;
  gap:16px;
}

.divSearchLyceumContentTitle{
  font-size: 24px;
}

.divSearchLyceumContentTitle20px{
  font-size: 18px;
}
.divSearchLyceumContentTitle20pxMaxWid{
  max-width: 100%;
  font-size: 18px;
}

.divSearchLyceumContentTitleBig{
  font-size: 28px;
  padding: 32px 0 16px 0;
}


.divSearchLyceumContentReturn{
  display: flex;
  flex-direction: column;
  margin: 32px 0 0 0;
  gap:16px;
}

.divSearchLyceumContentReturnMaster{
  display: flex;
  flex-direction: column;
  gap:16px;
}

.divSearchLyceumContentReturnRegister{
  display: flex;
  flex-direction: row;
  gap:32px;
  position: relative;
  width: 90%;
  padding-left:32px;
  cursor:pointer;
  margin:16px 0 16px 0;
}

.divSearchLyceumContentReturnRegister::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 7%; /* 10% de espaço em cada lado, resultando em 80% de largura */
  width: 50%;
  border-bottom: 1px solid white;
}
.divSearchLyceumContentReturnRegister:hover{
  color:#E97247;
}

.divSearchLyceumContentReturnRegisterImg{
  filter: invert(100%);
  width: 50px;
  height: auto;
}

.divSearchLyceumContentReturnClientData{
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  width: 70%;
  background-color: rgba(255, 255, 255, 0.3);
  border-radius: 16px;
  height: 50px;
  font-size: 20px;
}

.divSearchLyceumContentReturnDataResume{
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.4);
  border-radius: 16px;
  height: 50px;
  cursor:pointer;
  width: 70%;
}

.divSearchLyceumContentReturnDataResumeItem{
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 50px;
  cursor:pointer;
  gap: 32px;
  width: 50%;
}

.divSearchLyceumContentInput{
  height: 50px;
  background-color: rgba(255, 255, 255, 0.4);
  border: none;
  border-radius: 16px;
  color: white;
  font-size: 18px;
  width: 70%;
  padding-left: 20px;
  box-sizing: border-box;
}

.divSearchLyceumContentInput::placeholder {
  color: white;
}


.divSearchLyceumContentInput55{
  height: 50px;
  background-color: rgba(255, 255, 255, 0.4);
  border: none;
  border-radius: 16px;
  color: white;
  font-size: 18px;
  width: 55%;
  padding-left: 20px;
  box-sizing: border-box;
}

.divSearchLyceumContentInput55::placeholder {
  color: white;
}



.divSearchLyceumContentSelect{
  height: 50px;
  background-color: rgba(255, 255, 255, 0.4);
  border: none;
  border-radius: 16px;
  color: white;
  font-size: 18px;
  width: 55%;
  padding-left: 20px;
  box-sizing: border-box;
}

.divSearchLyceumContentSelect option {
  color: black; 
}

.divSearchLyceumContentButton{
  height: 50px;
  background-color: #E97247;
  border: none;
  border-radius: 16px;
  color: #ffffff;
  font-size: 20px;
  width: 350px;
  cursor:pointer;
}


.divSearchLyceumContentButton:hover{
  background-color: #ffffff;
  color: #E97247;
  font-size: 24px;
}

.divSearchLyceumContentButtonDisabled{
  height: 50px;
  background-color: #939393;
  border: none;
  border-radius: 16px;
  color: #ffffff;
  font-size: 20px;
  width: 350px;
  cursor:pointer;
}

.textDecorationNone{
  text-decoration: none;
  color: black;
}

.divSearchLyceumContentButtonLittle{
  height: 30px;
  background-color: #939393;
  border: none;
  border-radius: 16px;
  color: #ffffff;
  font-size: 16px;
  cursor:pointer;
  padding:10px;
}

.divSearchLyceumContentReturnIcons{
  display: flex;
  flex-direction: column;
  gap:16px;
  padding-left: 80px;
}

.divSearchLyceumContentReturnIconsContent{
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.divSearchLyceumContentReturnIconImg{
  width: 28px;
  height: auto;
}

.divSearchLyceumDivLogo{
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top:20%;
}

.divSearchLyceumLogo{
  width: 250px;
}


.divSearchLyceumPriceIcon{
  width: 40px;
}

.divLoadingSearchRegistration{
  display: flex;
  align-items: center;
}

.divSearchLyceumInfoReturnRegisterContent{
  display: flex;
  gap: 30px;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  padding:10px;
  width: 50%;
  min-width: 500px;
}

.divSearchLyceumNegociation{
  display: flex;
  flex-direction: column;
  padding: 16px 0 16px 32px;
  gap:32px;
  border-left: 2px solid white;
}

.divSearchLyceumNegociationColum{
  display: flex;
  flex-direction: column;
  gap:16px;
}

.divSearchLyceumNegociationRow{
  display: flex;
  flex-direction: row;
  max-width: 55%;
}
.divSearchLyceumNegociationRow > * {
  flex: 1 1;
  margin: 5px;
}

.divSearchLyceumJurosOption{
  padding:10px;
  border-radius: 8px;
  cursor:pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border: solid 1px white;
}


.divSearchLyceumJurosSelect{
  background-color: #E97247;
  padding:10px;
  border-radius: 8px;
  cursor:pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}


.divSearchLyceumColumn{
  display: flex;
  flex-direction: column;
  gap:16px;
}

.divSearchLyceumColumnAcordo{
  display: flex;
  flex-direction: column;
  gap:16px;
  margin: 16px 0 16px 0;
  padding:16px 16px 16px 32px;
  max-width: 55%;
  border: 1px solid white;
  border-radius: 16px;
}

.divSearchLyceumRow{
  display: flex;
  flex-direction: row;
  gap:16px;
  justify-content: center;
  align-items: center;
}


.divSearchLyceumColumnNotGap{
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 50%;
}

.divSearchLyceumColumnNotGapEdit{
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 50%;
  margin-top: 30px;
  padding-left: 16px;
  border-left: 1px solid white;
}

.divSearchLyceumDetailsClick{
  display: flex;
  padding: 8px;
  cursor: pointer;
  margin-top: 32px;
  width: 300px;
  border-radius: 10px;
  padding-left: 20px;
  background-color: rgba(255, 255, 255, 0.4);
}


.divSearchLyceumRowNotGap{
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.divSearchLyceumRowNotCenter{
  display: flex;
  flex-direction: row;
  gap:16px;
  justify-content: center;
  align-items: center;
}

 
.divSearchLyceumContentReturnIconContent{
  display: flex;
  flex-direction: row;
  gap:8px;
}


.divSearchLyceumSimulations{
  display: flex;
  flex-direction: column;
  border-radius: 16px;
  border: 1px solid white;
  padding:10px;
  margin-left:32px;
  width: 450px;
  margin-bottom: 16px;
  cursor:pointer;
}

.divSearchLyceumSimulationsSelected{
  display: flex;
  flex-direction: column;
  border-radius: 16px;
  background-color: #E97247;
  color:white;
  padding:15px 15px 15px 40px;
  margin-left:32px;
  width: 450px;
  margin-bottom: 16px;
  border: solid 1px white;
}

@media (max-width: 768px) {
  
  .divSearchLyceum{
    flex-direction: column;
  }
    
  .divSearchLyceumMenu{
    flex-direction: row;
    width: 100%;
    height: 80px;
    padding: 10px;
  }

    
  .divSearchLyceumContent{
    padding:10px 0 100px 20px;
    width: 100%;
    min-height: 150vh;
  }
    
  .divSearchLyceumContentSub{
    padding: 8px 0px 0px 16px;
    gap:16px;
  }
  
  .divSearchLyceumContentButton{
    width: 300px;
  }

  .divSearchLyceumContentInput{
    width: 300px;
    padding-left: 20px;
    box-sizing: border-box;
  }

  
  .divSearchLyceumContentInput55{
    width: 300px;
    padding-left: 20px;
    box-sizing: border-box;
  }

  
  .divSearchLyceumContentSelect{
    width: 300px;
    padding-left: 20px;
    box-sizing: border-box;
  }
    
    
  .divSearchLyceumContentReturnClientData{
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 300px;
    font-size: 16px;
    height: 300px;
    gap:6px;
  }

  .divSearchLyceumContentReturnRegister{
    gap:16px;
    padding-left:16px;
    cursor:pointer;
    margin:16px 0 16px 0;
    width: auto;
  }
    
  .divSearchLyceumContentReturnRegister::after {
    display: none;
  }

  .divSearchLyceumContentReturnDataResumeItem{
    cursor:pointer;
    width: 350px;
    height: auto;
    border-bottom: 1px solid #ffffff;
    margin: 0 50px 0 0;
    padding: 10px 0 10px 0;
    gap: 0px;
  }
  
  .divSearchLyceumContentReturnRegisterImg{
    display: none;
  }
 
.divSearchLyceumInfoReturnRegisterContent{
  gap: 16px;
  flex-direction: column;
  width: 250px;
  min-width: auto;
}
.divSearchLyceumContentReturnIcons{
  gap:16px;
  padding-left: 0;
}
.divSearchLyceumRow{
  flex-direction: column;
  gap:8px;
}

.divSearchLyceumRowNotCenter{
  flex-direction: column;
  gap:8px;
}
.divSearchLyceumNegociationRow{
  flex-direction: column;
  width: 90%;
}
    
.divSearchLyceumNegociation{
  padding: 0 0 0 16px;
  gap:16px;
}


.divSearchLyceumContentTitleBig{
  font-size: 24px;
  padding: 10px;
}
.divSearchLyceumContentButton{
  height: 50px;
  background-color: #E97247;
  border: none;
  border-radius: 16px;
  color: #ffffff;
  font-size: 20px;
  width: 300px;
  cursor:pointer;
}


.divSearchLyceumContentButtonDisabled{
  height: 50px;
  background-color: #939393;
  border: none;
  border-radius: 16px;
  color: #ffffff;
  font-size: 20px;
  width: 300px;
  cursor:pointer;
}


.divSearchLyceumContentButtonLittle{
  font-size:12px;
}


.divSearchLyceumSimulations{
  width: 250px;
}

.divSearchLyceumSimulationsSelected{
  width: 250px;
}


.divSearchLyceumContentTitle20px{
  font-size: 16px;
}

.divSearchLyceumContentTitle20pxMaxWid{
  font-size: 16px;
  max-width: 80%;
}

.divSearchLyceumColumnAcordo{
  max-width: 90%;
}

.divSearchLyceumColumnNotGapEdit{
  width: 300px;
}


.divSearchLyceumDetailsClick{
  margin-top: 64px;
}


}
`, "",{"version":3,"sources":["webpack://./src/pages/SearchLyceum/SearchLyceum.css"],"names":[],"mappings":";AACA;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,0BAA0B;EAC1B,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ,EAAE,6DAA6D;EACvE,UAAU;EACV,8BAA8B;AAChC;AACA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,UAAU;EACV,0CAA0C;EAC1C,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,0CAA0C;EAC1C,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;;AAGA;EACE,YAAY;EACZ,0CAA0C;EAC1C,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;;;AAIA;EACE,YAAY;EACZ,0CAA0C;EAC1C,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;;AAGA;EACE,yBAAyB;EACzB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,cAAc;EACd,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;;AAGA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,0CAA0C;EAC1C,mBAAmB;EACnB,YAAY;EACZ,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,QAAQ;EACR,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,SAAO;EACP,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;AACzB;;;AAGA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,qBAAqB;EACrB,2BAA2B;EAC3B,cAAc;EACd,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,mBAAmB;AACrB;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;AAC5C;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,mBAAmB;AACrB;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,OAAO;AACT;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE;IACE,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,aAAa;EACf;;;EAGA;IACE,yBAAyB;IACzB,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;IACzB,QAAQ;EACV;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;EACxB;;;EAGA;IACE,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;EACxB;;;EAGA;IACE,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;EACxB;;;EAGA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,OAAO;EACT;;EAEA;IACE,QAAQ;IACR,iBAAiB;IACjB,cAAc;IACd,oBAAoB;IACpB,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,YAAY;IACZ,gCAAgC;IAChC,kBAAkB;IAClB,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,aAAa;EACf;;AAEF;EACE,SAAS;EACT,sBAAsB;EACtB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,QAAQ;EACR,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,OAAO;AACT;;AAEA;EACE,sBAAsB;EACtB,OAAO;AACT;AACA;EACE,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,QAAQ;AACV;;;AAGA;EACE,eAAe;EACf,aAAa;AACf;AACA;EACE,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;;AAGA;EACE,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;;AAGA;EACE,cAAc;AAChB;;;AAGA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;;AAGA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;;AAGA;EACE,gBAAgB;AAClB;;;AAGA","sourcesContent":["\n.divSearchLyceum{\n    min-height: 100vh;\n    display: flex;\n    flex-direction: row;\n    color: white;\n}\n\n.divSearchLyceumMenu{\n  display: flex;\n  flex-direction: column;\n  width: 100px;\n  background-color: #FFFFFF;\n  color: black;\n  padding:32px 0 32px 0px ;\n}\n\n.divSearchLyceumContent{\n  display: flex;\n  flex-direction: column;\n  gap:24px;\n  padding:32px;\n  width: calc(100% - 100px);\n  background-color: #6051b7;\n  margin-left: 100px;\n}\n\n.divSearchLyceumContentSub{\n  display: flex;\n  flex-direction: column;\n  padding: 32px 0px 0px 64px;\n  gap:16px;\n}\n\n.divSearchLyceumContentTitle{\n  font-size: 24px;\n}\n\n.divSearchLyceumContentTitle20px{\n  font-size: 18px;\n}\n.divSearchLyceumContentTitle20pxMaxWid{\n  max-width: 100%;\n  font-size: 18px;\n}\n\n.divSearchLyceumContentTitleBig{\n  font-size: 28px;\n  padding: 32px 0 16px 0;\n}\n\n\n.divSearchLyceumContentReturn{\n  display: flex;\n  flex-direction: column;\n  margin: 32px 0 0 0;\n  gap:16px;\n}\n\n.divSearchLyceumContentReturnMaster{\n  display: flex;\n  flex-direction: column;\n  gap:16px;\n}\n\n.divSearchLyceumContentReturnRegister{\n  display: flex;\n  flex-direction: row;\n  gap:32px;\n  position: relative;\n  width: 90%;\n  padding-left:32px;\n  cursor:pointer;\n  margin:16px 0 16px 0;\n}\n\n.divSearchLyceumContentReturnRegister::after {\n  content: \"\";\n  position: absolute;\n  bottom: 0;\n  left: 7%; /* 10% de espaço em cada lado, resultando em 80% de largura */\n  width: 50%;\n  border-bottom: 1px solid white;\n}\n.divSearchLyceumContentReturnRegister:hover{\n  color:#E97247;\n}\n\n.divSearchLyceumContentReturnRegisterImg{\n  filter: invert(100%);\n  width: 50px;\n  height: auto;\n}\n\n.divSearchLyceumContentReturnClientData{\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-around;\n  width: 70%;\n  background-color: rgba(255, 255, 255, 0.3);\n  border-radius: 16px;\n  height: 50px;\n  font-size: 20px;\n}\n\n.divSearchLyceumContentReturnDataResume{\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  background-color: rgba(255, 255, 255, 0.4);\n  border-radius: 16px;\n  height: 50px;\n  cursor:pointer;\n  width: 70%;\n}\n\n.divSearchLyceumContentReturnDataResumeItem{\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  height: 50px;\n  cursor:pointer;\n  gap: 32px;\n  width: 50%;\n}\n\n.divSearchLyceumContentInput{\n  height: 50px;\n  background-color: rgba(255, 255, 255, 0.4);\n  border: none;\n  border-radius: 16px;\n  color: white;\n  font-size: 18px;\n  width: 70%;\n  padding-left: 20px;\n  box-sizing: border-box;\n}\n\n.divSearchLyceumContentInput::placeholder {\n  color: white;\n}\n\n\n.divSearchLyceumContentInput55{\n  height: 50px;\n  background-color: rgba(255, 255, 255, 0.4);\n  border: none;\n  border-radius: 16px;\n  color: white;\n  font-size: 18px;\n  width: 55%;\n  padding-left: 20px;\n  box-sizing: border-box;\n}\n\n.divSearchLyceumContentInput55::placeholder {\n  color: white;\n}\n\n\n\n.divSearchLyceumContentSelect{\n  height: 50px;\n  background-color: rgba(255, 255, 255, 0.4);\n  border: none;\n  border-radius: 16px;\n  color: white;\n  font-size: 18px;\n  width: 55%;\n  padding-left: 20px;\n  box-sizing: border-box;\n}\n\n.divSearchLyceumContentSelect option {\n  color: black; \n}\n\n.divSearchLyceumContentButton{\n  height: 50px;\n  background-color: #E97247;\n  border: none;\n  border-radius: 16px;\n  color: #ffffff;\n  font-size: 20px;\n  width: 350px;\n  cursor:pointer;\n}\n\n\n.divSearchLyceumContentButton:hover{\n  background-color: #ffffff;\n  color: #E97247;\n  font-size: 24px;\n}\n\n.divSearchLyceumContentButtonDisabled{\n  height: 50px;\n  background-color: #939393;\n  border: none;\n  border-radius: 16px;\n  color: #ffffff;\n  font-size: 20px;\n  width: 350px;\n  cursor:pointer;\n}\n\n.textDecorationNone{\n  text-decoration: none;\n  color: black;\n}\n\n.divSearchLyceumContentButtonLittle{\n  height: 30px;\n  background-color: #939393;\n  border: none;\n  border-radius: 16px;\n  color: #ffffff;\n  font-size: 16px;\n  cursor:pointer;\n  padding:10px;\n}\n\n.divSearchLyceumContentReturnIcons{\n  display: flex;\n  flex-direction: column;\n  gap:16px;\n  padding-left: 80px;\n}\n\n.divSearchLyceumContentReturnIconsContent{\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.divSearchLyceumContentReturnIconImg{\n  width: 28px;\n  height: auto;\n}\n\n.divSearchLyceumDivLogo{\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top:20%;\n}\n\n.divSearchLyceumLogo{\n  width: 250px;\n}\n\n\n.divSearchLyceumPriceIcon{\n  width: 40px;\n}\n\n.divLoadingSearchRegistration{\n  display: flex;\n  align-items: center;\n}\n\n.divSearchLyceumInfoReturnRegisterContent{\n  display: flex;\n  gap: 30px;\n  background-color: rgba(255, 255, 255, 0.1);\n  border-radius: 16px;\n  padding:10px;\n  width: 50%;\n  min-width: 500px;\n}\n\n.divSearchLyceumNegociation{\n  display: flex;\n  flex-direction: column;\n  padding: 16px 0 16px 32px;\n  gap:32px;\n  border-left: 2px solid white;\n}\n\n.divSearchLyceumNegociationColum{\n  display: flex;\n  flex-direction: column;\n  gap:16px;\n}\n\n.divSearchLyceumNegociationRow{\n  display: flex;\n  flex-direction: row;\n  max-width: 55%;\n}\n.divSearchLyceumNegociationRow > * {\n  flex: 1;\n  margin: 5px;\n}\n\n.divSearchLyceumJurosOption{\n  padding:10px;\n  border-radius: 8px;\n  cursor:pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: solid 1px white;\n}\n\n\n.divSearchLyceumJurosSelect{\n  background-color: #E97247;\n  padding:10px;\n  border-radius: 8px;\n  cursor:pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n\n.divSearchLyceumColumn{\n  display: flex;\n  flex-direction: column;\n  gap:16px;\n}\n\n.divSearchLyceumColumnAcordo{\n  display: flex;\n  flex-direction: column;\n  gap:16px;\n  margin: 16px 0 16px 0;\n  padding:16px 16px 16px 32px;\n  max-width: 55%;\n  border: 1px solid white;\n  border-radius: 16px;\n}\n\n.divSearchLyceumRow{\n  display: flex;\n  flex-direction: row;\n  gap:16px;\n  justify-content: center;\n  align-items: center;\n}\n\n\n.divSearchLyceumColumnNotGap{\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  width: 50%;\n}\n\n.divSearchLyceumColumnNotGapEdit{\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  width: 50%;\n  margin-top: 30px;\n  padding-left: 16px;\n  border-left: 1px solid white;\n}\n\n.divSearchLyceumDetailsClick{\n  display: flex;\n  padding: 8px;\n  cursor: pointer;\n  margin-top: 32px;\n  width: 300px;\n  border-radius: 10px;\n  padding-left: 20px;\n  background-color: rgba(255, 255, 255, 0.4);\n}\n\n\n.divSearchLyceumRowNotGap{\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n}\n\n.divSearchLyceumRowNotCenter{\n  display: flex;\n  flex-direction: row;\n  gap:16px;\n  justify-content: center;\n  align-items: center;\n}\n\n \n.divSearchLyceumContentReturnIconContent{\n  display: flex;\n  flex-direction: row;\n  gap:8px;\n}\n\n\n.divSearchLyceumSimulations{\n  display: flex;\n  flex-direction: column;\n  border-radius: 16px;\n  border: 1px solid white;\n  padding:10px;\n  margin-left:32px;\n  width: 450px;\n  margin-bottom: 16px;\n  cursor:pointer;\n}\n\n.divSearchLyceumSimulationsSelected{\n  display: flex;\n  flex-direction: column;\n  border-radius: 16px;\n  background-color: #E97247;\n  color:white;\n  padding:15px 15px 15px 40px;\n  margin-left:32px;\n  width: 450px;\n  margin-bottom: 16px;\n  border: solid 1px white;\n}\n\n@media (max-width: 768px) {\n  \n  .divSearchLyceum{\n    flex-direction: column;\n  }\n    \n  .divSearchLyceumMenu{\n    flex-direction: row;\n    width: 100%;\n    height: 80px;\n    padding: 10px;\n  }\n\n    \n  .divSearchLyceumContent{\n    padding:10px 0 100px 20px;\n    width: 100%;\n    min-height: 150vh;\n  }\n    \n  .divSearchLyceumContentSub{\n    padding: 8px 0px 0px 16px;\n    gap:16px;\n  }\n  \n  .divSearchLyceumContentButton{\n    width: 300px;\n  }\n\n  .divSearchLyceumContentInput{\n    width: 300px;\n    padding-left: 20px;\n    box-sizing: border-box;\n  }\n\n  \n  .divSearchLyceumContentInput55{\n    width: 300px;\n    padding-left: 20px;\n    box-sizing: border-box;\n  }\n\n  \n  .divSearchLyceumContentSelect{\n    width: 300px;\n    padding-left: 20px;\n    box-sizing: border-box;\n  }\n    \n    \n  .divSearchLyceumContentReturnClientData{\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    width: 300px;\n    font-size: 16px;\n    height: 300px;\n    gap:6px;\n  }\n\n  .divSearchLyceumContentReturnRegister{\n    gap:16px;\n    padding-left:16px;\n    cursor:pointer;\n    margin:16px 0 16px 0;\n    width: auto;\n  }\n    \n  .divSearchLyceumContentReturnRegister::after {\n    display: none;\n  }\n\n  .divSearchLyceumContentReturnDataResumeItem{\n    cursor:pointer;\n    width: 350px;\n    height: auto;\n    border-bottom: 1px solid #ffffff;\n    margin: 0 50px 0 0;\n    padding: 10px 0 10px 0;\n    gap: 0px;\n  }\n  \n  .divSearchLyceumContentReturnRegisterImg{\n    display: none;\n  }\n \n.divSearchLyceumInfoReturnRegisterContent{\n  gap: 16px;\n  flex-direction: column;\n  width: 250px;\n  min-width: auto;\n}\n.divSearchLyceumContentReturnIcons{\n  gap:16px;\n  padding-left: 0;\n}\n.divSearchLyceumRow{\n  flex-direction: column;\n  gap:8px;\n}\n\n.divSearchLyceumRowNotCenter{\n  flex-direction: column;\n  gap:8px;\n}\n.divSearchLyceumNegociationRow{\n  flex-direction: column;\n  width: 90%;\n}\n    \n.divSearchLyceumNegociation{\n  padding: 0 0 0 16px;\n  gap:16px;\n}\n\n\n.divSearchLyceumContentTitleBig{\n  font-size: 24px;\n  padding: 10px;\n}\n.divSearchLyceumContentButton{\n  height: 50px;\n  background-color: #E97247;\n  border: none;\n  border-radius: 16px;\n  color: #ffffff;\n  font-size: 20px;\n  width: 300px;\n  cursor:pointer;\n}\n\n\n.divSearchLyceumContentButtonDisabled{\n  height: 50px;\n  background-color: #939393;\n  border: none;\n  border-radius: 16px;\n  color: #ffffff;\n  font-size: 20px;\n  width: 300px;\n  cursor:pointer;\n}\n\n\n.divSearchLyceumContentButtonLittle{\n  font-size:12px;\n}\n\n\n.divSearchLyceumSimulations{\n  width: 250px;\n}\n\n.divSearchLyceumSimulationsSelected{\n  width: 250px;\n}\n\n\n.divSearchLyceumContentTitle20px{\n  font-size: 16px;\n}\n\n.divSearchLyceumContentTitle20pxMaxWid{\n  font-size: 16px;\n  max-width: 80%;\n}\n\n.divSearchLyceumColumnAcordo{\n  max-width: 90%;\n}\n\n.divSearchLyceumColumnNotGapEdit{\n  width: 300px;\n}\n\n\n.divSearchLyceumDetailsClick{\n  margin-top: 64px;\n}\n\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
